// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__7myqx","error":"style_error__ZjxwL","formItem":"style_formItem__PshPA"};